// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.customTab.MuiButtonBase-root.MuiTab-root {
  color: black;
  font-weight: 500;
  font-size: 24px;
  font-style: normal;
  font-family: "Poppins";
  text-transform: none;
}

.MuiTabs-root.css-1ujnqem-MuiTabs-root{
  width: fit-content;
}
`, "",{"version":3,"sources":["webpack://./src/components/pages/orderManagement/transactionPage.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,sBAAsB;EACtB,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;AACpB","sourcesContent":[".customTab.MuiButtonBase-root.MuiTab-root {\n  color: black;\n  font-weight: 500;\n  font-size: 24px;\n  font-style: normal;\n  font-family: \"Poppins\";\n  text-transform: none;\n}\n\n.MuiTabs-root.css-1ujnqem-MuiTabs-root{\n  width: fit-content;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
